import en from "../assets/lang/en.json";

export default en;